type EmbedDetectionWindow = {
  self?: unknown;
  top?: unknown;
};

const TRUE_QUERY_VALUES = new Set(['1', 'true', 'yes']);
const FALSE_QUERY_VALUES = new Set(['0', 'false', 'no']);

export const resolveEmbeddedMode = (
  search: string,
  currentWindow: EmbedDetectionWindow | undefined = globalThis.window,
) => {
  const params = new URLSearchParams(search);
  const isIframeFlag = params.get('isIframe')?.trim().toLowerCase();

  if (isIframeFlag && TRUE_QUERY_VALUES.has(isIframeFlag)) {
    return true;
  }

  if (isIframeFlag && FALSE_QUERY_VALUES.has(isIframeFlag)) {
    return false;
  }

  if (!currentWindow) {
    return false;
  }

  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    return true;
  }
};
